export const navConfig = [
    {
        title: 'AI生成创意',
        value: 'aiCreateFrontPage',
        authorizedRole: 'digital_human_list',
        forbidOuterUser: true, // 不允许外部用户访问
        hideRole: 'digital_is_passport',
        routeName: 'aiCreateFrontPage'
    },
    {
        title: '广告文案创作',
        value: 'textCreateWork',
        // head区导航显示名单
        authorizedRole: 'digital_human_list',
        hideRole: 'digital_is_passport',
        routeName: 'textCreateWork'
    },
    {
        title: '图像生成',
        value: 'imageCreateWork',
        // head区导航显示名单
        authorizedRole: 'digital_education_image',
        hideRole: 'digital_is_passport',
        routeName: 'imageCreateWork'
    },
    {
        title: '数字人',
        value: 'digitalConsole',
        // head区导航显示名单
        authorizedRole: 'digital_human_list',
        routeName: 'digitalConsole'
    },
    {
        title: '创意资产',
        value: 'assetsLibraryPictrue',
        authorizedRole: 'digital_human_list',
        hideRole: 'digital_is_passport',
        children: [
            {
                title: '图片库',
                value: 'assetsLibraryPictrue',
                authorizedRole: 'digital_education_image'
            },
            {
                title: '视频库',
                value: 'assetsLibraryVideo'
            }
        ]
    }
];
